import {
    PriorityIcon,
    Icon,
    DropdownV2,
    ToggleSwitch,
    Text,
    Flex
} from '@priority-software/priority-style-react';
import React, {useCallback, useState} from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import {MapSettings} from '../../types';
import {texts} from '../../texts';

type Props = {
    componentClasses?: string;
    usePortal?: boolean;
    portalId?: string;
    mapSettings: MapSettings;
    onShowAddress?: (show: boolean) => void;
    onShowStartEnd?: (show: boolean) => void;
    onShowLines?: (show: boolean) => void;
};

export const HamburgerMenu = ({
    componentClasses,
    usePortal,
    portalId,
    mapSettings,
    onShowAddress,
    onShowStartEnd,
    onShowLines
}: Props) => {
    const [isOpen, setOpen] = useState(false);

    const handleOpen = useCallback(() => {
        setOpen(prev => !prev);
    }, []);

    const onCLose = useCallback(() => {
        setOpen(false);
    }, []);

    const {showAddresses, showLine, showStartEnd} = mapSettings;

    return (
        <DropdownV2
            isOpen={isOpen}
            onClose={onCLose}
            componentClasses={cx(styles.dropdownContent, componentClasses)}
            contentComponentClasses={styles.content}
            usePortal={usePortal}
            portalSelector={portalId}
            trigger={
                <Icon
                    icon={PriorityIcon.burger}
                    onClick={handleOpen}
                    componentClasses={styles.trigger}
                />
            }
        >
            <div className={styles.container}>
                <Flex componentClasses={styles.item}>
                    <ToggleSwitch
                        id={'show_route'}
                        componentClasses={styles.labelButton}
                        checked={showLine}
                        onChange={onShowLines}
                    />
                    <Text>{texts.show_route_lines}</Text>
                </Flex>
                <Flex componentClasses={styles.item}>
                    <ToggleSwitch
                        id={'show_addresses'}
                        componentClasses={styles.labelButton}
                        checked={showAddresses}
                        onChange={onShowAddress}
                    />
                    <Text>{texts.show_addresses}</Text>
                </Flex>
                <Flex componentClasses={styles.item}>
                    <ToggleSwitch
                        id={'show_start_end'}
                        componentClasses={styles.labelButton}
                        checked={showStartEnd}
                        onChange={onShowStartEnd}
                    />
                    <Text>{texts.show_start_end}</Text>
                </Flex>
            </div>
        </DropdownV2>
    );
};
